/** Default empty structured address (Firestore user doc). */
export const ADDRESS_FIELD_DEFAULTS = {
  addressLine1: '',
  addressLine2: '',
  addressCity: '',
  addressRegion: '',
  addressPostcode: '',
  addressCountry: '',
};

/**
 * Multi-line string for legacy `address` field and display.
 */
export function composeFullAddress(a) {
  const line1 = (a.addressLine1 || '').trim();
  const line2 = (a.addressLine2 || '').trim();
  const city = (a.addressCity || '').trim();
  const region = (a.addressRegion || '').trim();
  const pc = (a.addressPostcode || '').trim();
  const country = (a.addressCountry || '').trim();

  const cityRegion = [city, region].filter(Boolean).join(', ');
  const lines = [line1, line2, cityRegion, pc, country].filter(Boolean);
  return lines.join('\n').trim();
}

/**
 * Load structured fields from Firestore; migrate legacy single `address` into line 1.
 */
export function profileDataToAddressState(d) {
  if (!d) return { ...ADDRESS_FIELD_DEFAULTS };
  const hasStructured =
    d.addressLine1 ||
    d.addressLine2 ||
    d.addressCity ||
    d.addressRegion ||
    d.addressPostcode ||
    d.addressCountry;
  if (hasStructured) {
    return {
      addressLine1: d.addressLine1 || '',
      addressLine2: d.addressLine2 || '',
      addressCity: d.addressCity || '',
      addressRegion: d.addressRegion || '',
      addressPostcode: d.addressPostcode || '',
      addressCountry: d.addressCountry || '',
    };
  }
  const legacy = (d.address && String(d.address).trim()) ? String(d.address).trim() : '';
  return { ...ADDRESS_FIELD_DEFAULTS, addressLine1: legacy };
}

/**
 * True if required address parts are filled (line1, city, postcode, country).
 */
export function isAddressComplete(a) {
  return (
    !!(a.addressLine1 || '').trim() &&
    !!(a.addressCity || '').trim() &&
    !!(a.addressPostcode || '').trim() &&
    !!(a.addressCountry || '').trim()
  );
}
